<script setup lang="ts">
import type { ToolActivity } from '@/types'

defineProps<{ activity: ToolActivity }>()
</script>

<template>
  <div
    class="text-xs px-3 py-1.5 rounded-md my-0.5 max-w-[85%] self-start border-l-[3px] transition-colors"
    :class="[
      activity.status === 'executing'
        ? 'border-amber-500 text-amber-700 bg-amber-50'
        : activity.status === 'error'
          ? 'border-red-500 text-red-700 bg-red-50'
          : 'border-green-500 text-neutral-500 bg-neutral-50',
    ]"
  >
    <span
      v-if="activity.status === 'executing'"
      class="inline-block w-1.5 h-1.5 bg-amber-500 rounded-full mr-1.5 animate-pulse-dot"
    />
    <span v-else-if="activity.status === 'error'" class="mr-1.5">&#10007;</span>
    {{ activity.detail || activity.label }}
  </div>
</template>
